module.exports = __webpack_public_path__ + "static/media/DTD-2025-LOGO.cb7ed0f2.png";